import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { CurrencyProvider } from './context/CurrencyContext';
import ChatbotWrapper from './components/chatbot/ChatbotWrapper';
import SiteHead from './components/layout/SiteHead';

// Pages
import HomePage from './pages/home/HomePage';
import ServicesPage from './pages/services';
import AITrainingPage from './pages/services/ai-training';
import AIOnboardingPage from './pages/services/ai-onboarding';
import WorkflowAutomationPage from './pages/services/workflow-automation';
import CustomAIDevelopmentPage from './pages/services/custom-ai-development';
import AIOptimizationPage from './pages/services/ai-optimization';
import ContactPage from './pages/contact';
import AboutPage from './pages/about';
import BlogPage from './pages/blog';
import ResourcesPage from './pages/resources';
import GuidesPage from './pages/resources/guides';
import VideoTutorialsPage from './pages/resources/video-tutorials';
import CaseStudiesPage from './pages/case-studies';
import CaseStudyDetail from './pages/case-studies/[slug]';
import IndustriesPage from './pages/industries';
import HealthcareIndustryPage from './pages/industries/healthcare';
import FinanceIndustryPage from './pages/industries/finance';
import RetailIndustryPage from './pages/industries/retail';
import ManufacturingIndustryPage from './pages/industries/manufacturing';
import EducationIndustryPage from './pages/industries/education';
import LegalIndustryPage from './pages/industries/legal';
import IndividualsPage from './pages/solutions/individuals';
import SmallBusinessPage from './pages/solutions/small-business';
import StartupsPage from './pages/solutions/startups';
import ServiceSelectorPage from './pages/tools/service-selector';
import PricingCalculatorPage from './pages/tools/pricing-calculator';
import ApiTestPage from './pages/tools/api-test';
import PrivacyPolicy from './pages/legal/privacy-policy';
import TermsOfService from './pages/legal/terms-of-service';
import CookiesPolicy from './pages/legal/cookies';

/**
 * Main application component with routing
 */
const App: React.FC = () => {
  return (
    <ThemeProvider>
      <CurrencyProvider>
        <SiteHead />
        <Router>
          <Routes>
          <Route path="/" element={<HomePage />} />
          
          {/* Service pages */}
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/ai-training" element={<AITrainingPage />} />
          <Route path="/services/ai-onboarding" element={<AIOnboardingPage />} />
          <Route path="/services/workflow-automation" element={<WorkflowAutomationPage />} />
          <Route path="/services/custom-ai-development" element={<CustomAIDevelopmentPage />} />
          <Route path="/services/ai-optimization" element={<AIOptimizationPage />} />
          
          {/* Solution pages */}
          <Route path="/solutions/individuals" element={<IndividualsPage />} />
          <Route path="/solutions/small-business" element={<SmallBusinessPage />} />
          <Route path="/solutions/startups" element={<StartupsPage />} />
          <Route path="/solutions/industries" element={<Navigate to="/industries" replace />} />
          
          {/* Tool pages */}
          <Route path="/tools/service-selector" element={<ServiceSelectorPage />} />
          <Route path="/tools/pricing-calculator" element={<PricingCalculatorPage />} />
          <Route path="/tools/api-test" element={<ApiTestPage />} />
          
          {/* Other main pages */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/resources/guides" element={<GuidesPage />} />
          <Route path="/resources/videos" element={<VideoTutorialsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          
          {/* Case Studies pages */}
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
          
          {/* Industry pages */}
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/industries/healthcare" element={<HealthcareIndustryPage />} />
          <Route path="/industries/finance" element={<FinanceIndustryPage />} />
          <Route path="/industries/retail" element={<RetailIndustryPage />} />
          <Route path="/industries/manufacturing" element={<ManufacturingIndustryPage />} />
          <Route path="/industries/education" element={<EducationIndustryPage />} />
          <Route path="/industries/legal" element={<LegalIndustryPage />} />
          
          {/* Legal pages */}
          <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/legal/terms-of-service" element={<TermsOfService />} />
          <Route path="/legal/cookies" element={<CookiesPolicy />} />
          
          {/* Page not found */}
          <Route path="*" element={<div>Page not found</div>} />
        </Routes>
        </Router>
        <ChatbotWrapper />
      </CurrencyProvider>
    </ThemeProvider>
  );
};

export default App;